function Help() {
    return(<div className={"content"}>
        <h1>Support</h1>
        <p>For all support queries - please contact your sales rep. Interested in joining? Fill out an application form and we will be in touch!</p>
    </div>)
}

export default Help;